import React, { useState } from 'react';
import { supabase } from '../supabase';
import { userService, postService } from '../services/supabaseService';

function DatabaseDebug({ user }) {
  const [debugInfo, setDebugInfo] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const testDatabase = async () => {
    setIsLoading(true);
    setDebugInfo('🔍 Testando conexão com banco de dados...\n\n');
    
    try {
      // Teste 1: Verificar se o usuário existe na tabela users
      setDebugInfo(prev => prev + '1️⃣ Testando tabela users...\n');
      
      const { data: userData, error: userError } = await supabase
        .from('users')
        .select('*')
        .eq('id', user.id);
      
      if (userError) {
        setDebugInfo(prev => prev + `❌ Erro na tabela users: ${userError.message}\n\n`);
      } else if (!userData || userData.length === 0) {
        setDebugInfo(prev => prev + `⚠️ Usuário não existe na tabela users! Criando...\n`);
        
        // Criar o usuário na tabela
        const { data: createdUser, error: createError } = await supabase
          .from('users')
          .insert([{
            id: user.id,
            nome: user.user_metadata?.nome || user.email.split('@')[0] || 'Usuário',
            email: user.email,
            created_at: new Date().toISOString()
          }])
          .select();
          
        if (createError) {
          setDebugInfo(prev => prev + `❌ Erro ao criar usuário: ${createError.message}\n\n`);
        } else {
          setDebugInfo(prev => prev + `✅ Usuário criado! Nome: ${createdUser[0]?.nome}\n\n`);
        }
      } else {
        setDebugInfo(prev => prev + `✅ Tabela users OK! Nome: ${userData[0]?.nome || 'Sem nome'}\n\n`);
      }

      // Teste 2: Verificar tabela posts
      setDebugInfo(prev => prev + '2️⃣ Testando tabela posts...\n');
      
      const { data: postsData, error: postsError } = await supabase
        .from('posts')
        .select('*')
        .limit(1);
      
      if (postsError) {
        setDebugInfo(prev => prev + `❌ Erro na tabela posts: ${postsError.message}\n\n`);
      } else {
        setDebugInfo(prev => prev + `✅ Tabela posts OK! Posts encontrados: ${postsData?.length || 0}\n\n`);
      }

      // Teste 3: Tentar criar um post de teste
      setDebugInfo(prev => prev + '3️⃣ Testando criação de post...\n');
      
      const testPostData = {
        user_id: user.id,
        conteudo: 'Post de teste - ' + new Date().toISOString(),
        foto: '',
        video: '',
        created_at: new Date().toISOString()
      };

      console.log('🔍 Dados do post de teste:', testPostData);
      const newPost = await postService.createPost(testPostData);
      console.log('🔍 Resultado do post:', newPost);
      
      if (newPost && !newPost.id.startsWith('temp_')) {
        setDebugInfo(prev => prev + `✅ Post criado com sucesso! ID: ${newPost.id}\n\n`);
      } else {
        setDebugInfo(prev => prev + `⚠️ Post criado apenas em fallback (sem banco real)\n\n`);
      }

      // Teste 4: Buscar posts
      setDebugInfo(prev => prev + '4️⃣ Testando busca de posts...\n');
      
      const allPosts = await postService.getAllPosts();
      setDebugInfo(prev => prev + `📊 Posts encontrados: ${allPosts.length}\n\n`);

      setDebugInfo(prev => prev + '🎯 DIAGNÓSTICO:\n');
      
      if (userError || postsError) {
        setDebugInfo(prev => prev + '❌ AS TABELAS NÃO FORAM CRIADAS NO SUPABASE!\n');
        setDebugInfo(prev => prev + '📋 SOLUÇÃO: Execute o arquivo supabase_schema.sql no SQL Editor do Supabase\n');
      } else {
        setDebugInfo(prev => prev + '✅ Banco de dados configurado corretamente!\n');
      }

    } catch (error) {
      setDebugInfo(prev => prev + `💥 Erro geral: ${error.message}\n`);
    }
    
    setIsLoading(false);
  };

  return (
    <div style={{ 
      position: 'fixed', 
      top: '10px', 
      right: '10px', 
      background: 'white', 
      border: '2px solid #ccc', 
      padding: '15px', 
      maxWidth: '400px',
      maxHeight: '500px',
      overflow: 'auto',
      zIndex: 9999,
      fontSize: '12px',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
    }}>
      <h3>🔧 Debug do Banco</h3>
      
      <button 
        onClick={testDatabase} 
        disabled={isLoading}
        style={{
          background: '#007bff',
          color: 'white',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '4px',
          cursor: 'pointer',
          marginBottom: '10px'
        }}
      >
        {isLoading ? '⏳ Testando...' : '🧪 Testar Banco'}
      </button>

      {debugInfo && (
        <pre style={{ 
          background: '#f8f9fa', 
          padding: '10px', 
          borderRadius: '4px',
          whiteSpace: 'pre-wrap',
          fontSize: '11px',
          lineHeight: '1.3'
        }}>
          {debugInfo}
        </pre>
      )}
    </div>
  );
}

export default DatabaseDebug;